// src/components/stati/StatoForm.jsx
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Save, X } from "lucide-react";
import { useState } from "react";

export default function StatoForm({ stato, onSubmit, onCancel, isLoading = false }) {
  const [formData, setFormData] = useState({
    nome: stato?.nome || "",
    descrizione: stato?.descrizione || ""
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Card className="glass-effect border-0 shadow-xl">
      <CardHeader className="p-6 border-b border-slate-100">
        <CardTitle className="text-xl font-bold text-slate-800">
          {stato ? "Modifica Stato" : "Nuovo Stato"}
        </CardTitle>
      </CardHeader>
      <CardContent className="p-6">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="nome" className="text-sm font-medium text-slate-700">
              Nome Stato *
            </Label>
            <Input
              id="nome"
              value={formData.nome}
              onChange={(e) => handleChange("nome", e.target.value)}
              placeholder="es. Parcheggiata"
              required
              disabled={isLoading}
              className="glass-effect border-0 shadow-sm"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="descrizione" className="text-sm font-medium text-slate-700">
              Descrizione
            </Label>
            <Textarea
              id="descrizione"
              value={formData.descrizione}
              onChange={(e) => handleChange("descrizione", e.target.value)}
              placeholder="Descrizione dello stato..."
              rows={3}
              disabled={isLoading}
              className="glass-effect border-0 shadow-sm"
            />
          </div>

          <div className="flex justify-end gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onCancel}
              disabled={isLoading}
              className="px-6"
            >
              <X className="w-4 h-4 mr-2" />
              Annulla
            </Button>
            <Button
              type="submit"
              disabled={isLoading}
              className="bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white px-6"
            >
              <Save className="w-4 h-4 mr-2" />
              {isLoading ? 'Salvando...' : 'Salva'}
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
}